import { useDateFns } from '~/Hooks';
import { WeekDay } from '~/Models/DTO/Provider.model';

export const useCheckForErrors = () => {
  const { convertTimeStringToDate, isBeforeDate } = useDateFns();

  const checkForErrors = (weekday: WeekDay, previousWeekDay: WeekDay | undefined) => {
    const blockFromTime = convertTimeStringToDate(weekday.from);
    const blockToTime = convertTimeStringToDate(
      weekday.to === '00:00:00' ? '24:00:00' : weekday.to,
    );
    if (isBeforeDate(blockToTime.toString(), blockFromTime.toString())) {
      return true;
    }
    if (previousWeekDay) {
      const lastBlockToTime = convertTimeStringToDate(previousWeekDay.to.toString());

      if (isBeforeDate(blockFromTime.toString(), lastBlockToTime.toString())) {
        return true;
      }
    }
    return false;
  };

  return { checkForErrors };
};
